import parse from 'html-react-parser';
const HTMLComponent = (props) => {
    if(props.children){
        return parse(props.children)
    }
};
export default HTMLComponent;
